import { createShortcut, RicosPluginToolbarNames } from "./../ricos-types";
import { Decoration_Type, RICOS_ANCHOR_TYPE, RICOS_LINK_TYPE } from "./../wix-rich-content-common";
import { DECORATION_LINK_MODAL_ID } from "./../toolbars-modals";
import { RESOLVERS_IDS } from "./../toolbars-v3/lib/resolvers-ids";
import { anchorConverter } from "./anchor-converter";
import { ADD_LINK_BUTTON } from "./dataHooks";
import { DEFAULTS } from "./defaults";
import { getToolbarButtons } from "./get-toolbar-buttons";
import { linkConverter } from "./link-converter";
import LinkIcon from "./LinkIcon";
import LinkPanelComponent from "./LinkPanelComponent";
import { LINK_TYPE } from "./types";
const pluginLink = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: LINK_TYPE,
    pmNodeConverters: [],
    pmMarkConverters: [linkConverter, anchorConverter],
    shortcuts: [
      createShortcut({
        name: Decoration_Type.LINK,
        description: "ShortcutsSheet_Formatting_Link",
        group: "ShortcutsSheet_Section_Formatting",
        keys: {
          macOs: "Meta+K",
          windows: "Ctrl+K"
        },
        enabled: true,
        command({ editorCommands, modalService }) {
          if (editorCommands.hasLinkInSelection()) {
            const link = editorCommands.getLinkDataInSelection();
            const linkType = link?.url ? RICOS_LINK_TYPE : RICOS_ANCHOR_TYPE;
            editorCommands.deleteDecoration(linkType);
          } else {
            modalService.openModal(DECORATION_LINK_MODAL_ID, {
              layout: "dialog"
            });
          }
        }
      })
    ],
    toolbar: {
      names: [RicosPluginToolbarNames.LINK],
      getButtons: getToolbarButtons,
      isVisible: (selection, editor) => {
        const isSelectionCollapsed = (selection2) => {
          const { from, to } = selection2;
          return to - from <= 0;
        };
        const isCollapsed = isSelectionCollapsed(selection);
        const isLinkInSelection = editor.getEditorCommands().hasLinkInSelection();
        return isCollapsed && isLinkInSelection;
      }
    },
    textButtons: [
      {
        id: Decoration_Type.LINK,
        type: "modal",
        presentation: {
          dataHook: ADD_LINK_BUTTON,
          tooltip: "TextLinkButton_Tooltip",
          icon: LinkIcon
        },
        attributes: {
          visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
          active: RESOLVERS_IDS.IS_TEXT_CONTAINS_LINK_OR_ANCHOR,
          disabled: RESOLVERS_IDS.IS_NODE_SELECTED
        },
        commands: {},
        modal: {
          id: DECORATION_LINK_MODAL_ID,
          Component: LinkPanelComponent,
          layout: {
            desktop: "drawer",
            mobile: "fullscreen"
          },
          noPadding: true
        }
      }
    ]
  };
};
export {
  pluginLink
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
